export default function (state) {
  state.loading = false;
  state.auth = false;
  state.id = null;
  state.departmentId = null;
  state.needSelectDepartment = null;
  state.name = '';
  state.type = '';
  state.fullName = '';
  state.departmentName = '';
  state.partnerId = '';
  state.isSubAgent = false;
  state.isReservationCenter = true;
}